import React, { useEffect, useState } from 'react';
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import './professionals-services.css';

const Professionals = () => {

    const [services, setServices] = useState([]);
    const url = 'https://api.abranches.net.br/Service/get?serviceId=467b4936-dd01-4735-a71d-4aff3657a5f9';

    useEffect(() => {
        async function fetchData() {
            try {
                const res = await fetch(url);



                const data = await res.json();
                setServices(data);

            } catch (error) {
                console.error('Erro ao buscar serviços:', error);
            }
        }

        fetchData();
    }, []);

    useEffect(() => {
        console.log(services);
    }, [services]);

    return (
        <div>
            <div className='service-professional'>
                <div className='service-professional-list'>
                    <ul>
                        {services.map((service) => (
                            <li key={service.id}>
                                {service.name}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='service-professional-list'>
                    <ul>
                        <li className="active">Humberto</li>
                        <li>Frederico</li>
                        <li>Marcos</li>
                        <li>Figueredo</li>
                    </ul>
                </div>
            </div>

            <div className="date-booking">
                <HiChevronLeft className="icon" />
                <span className="text">
                    Segunda Feira, 20 de abril de 2026
                </span>
                <HiChevronRight className="icon" />
            </div>

            <div className="div-line">
                <div className="line"></div>
            </div>
        </div>
    );
};

export default Professionals;